import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { WindowEnums } from 'src/app/enum/window-enums';
import { ActionColor, CheckBoxAction, TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { CostCenterPriceModel } from 'src/app/models/archive/cost-center-price.model';
import { TransferConstructionSiteDetailModel } from 'src/app/models/rental/transfer-construction-site-detail.model';
import { TransferConstructionSiteModel } from 'src/app/models/rental/transfer-construction-site.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { RentalStockModalModel } from 'src/app/models/tables/rental/rental-stock-modal.model';
import { TransferConstructionSiteDetailRegisterModel } from 'src/app/models/tables/rental/transfer-construction-site-detail-register.model';
import { WindowService } from 'src/app/services/authentication/window.service';
import { TransferConstructionSiteDetailService } from 'src/app/services/rental/transfer-construction-site-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { RegisterCostCenterPriceComponent } from 'src/app/views/archive/cost-center-price/register-cost-center-price/register-cost-center-price.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-transfer-construction-site-detail',
  templateUrl: './transfer-construction-site-detail.component.html',
  styleUrls: ['./transfer-construction-site-detail.component.scss'],
  standalone: false,
})
export class TransferConstructionSiteDetailComponent implements OnInit, OnChanges {

  private readonly transferConstructionSiteDetailService = inject(TransferConstructionSiteDetailService);
  private readonly toastHandlerService = inject(ToastHandlerService);
  private readonly windowService = inject(WindowService);

  @ViewChild('articleSelection') articleSelectionModalComponent?: CustomModalComponent | null = null;
  @ViewChild('costCenterPriceRegisterModal') costCenterPriceRegisterComponent?: CustomModalComponent | null = null;
  @Input() disabledActions: boolean = false;
  @Input() disabledDetail: boolean = false;
  @Input() transferConstructionSiteModel: TransferConstructionSiteModel = new TransferConstructionSiteModel();
  @Output() emitQuantityDetails = new EventEmitter<number>();
  @Output() hasQuantityInZero = new EventEmitter<boolean>();

  accessCostCenterPrice: boolean = false;
  ascendant: boolean = true;
  ascendantArticle: boolean = true;
  checkboxActions: CheckBoxAction[] = [
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      color: ActionColor.DANGER,
      action: 'bulk-delete'
    },
  ];
  clearSelectionTrigger: number = 0;
  columnSort: string | null = null;
  columnSortArticle: string | null = null;
  componentRegisterModal = RegisterCostCenterPriceComponent;
  componentTableSelection = CustomTableSelectComponent;
  conceptInvoicingId: number = 0;
  costCenterPriceContract: CostCenterPriceModel = new CostCenterPriceModel();
  dataArticle: PagedResponseModel<RentalStockModalModel> = new PagedResponseModel<RentalStockModalModel>();
  detailData: PagedResponseModel<TransferConstructionSiteDetailRegisterModel> = new PagedResponseModel<TransferConstructionSiteDetailRegisterModel>();
  detailHeader: ColumnResponseModel[] = [];
  disabledButton: boolean = true;
  filtersArticle: ColumnResponseModel[] = []
  formTransferConstructionSite: FormGroup = new FormGroup({});
  headerArticle: ColumnResponseModel[] = [];
  inputsForArticlesSelection$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: false,
    showRecover: true,
    isMultipleSelect: true,
    filters: [],
    actions: [],
  });
  inputsForCostCenterPriceRegisterModals$ = new BehaviorSubject<any>({
    blockForm: false,
    costCenterPriceModel: new CostCenterPriceModel(),
    openFrom: ''
  });
  isFormView: boolean = false;
  limit: number = 10;
  limitArticle: number = 5;
  openCostCenterPriceRegister: boolean = false;
  openFromCostCenterPrice: string = '';
  output$ = new Subject<any>();
  page: number = 1;
  pageArticle: number = 1;
  subscription: Subscription;
  tableActions: TableAction[] = [];
  transferConstructionSiteDetail: TransferConstructionSiteDetailModel = new TransferConstructionSiteDetailModel();
  transferConstructionSiteDetails: TransferConstructionSiteDetailModel[] = [];

  async ngOnInit() {
    await this.getColumnsForDetailsTransferConstructionSite();
    await this.getWindowsByUserAuthenticated();
    this.tableActions = this.getDefaultActions();
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeArticle(payload);
          break;
        case 'onFilterChange':
          this.onFilterChange(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    const disabledActions = changes["disabledActions"];
    const transferConstructionSiteModel = changes["transferConstructionSiteModel"];
    if (transferConstructionSiteModel && !transferConstructionSiteModel.firstChange) {
      this.getFormView(false);
      this.getUpdateListDetail();
      this.transferConstructionSiteDetail = new TransferConstructionSiteDetailModel();
    }
    if (disabledActions && !disabledActions.firstChange) {
      this.tableActions = this.disabledActions ? [] : this.getDefaultActions();
    }
  }

  async deleteTransferConstructionSiteDetail(selectedIds: number[]) {
    if (selectedIds.length === 0) return;
    const result = await Swal.fire({
      title: 'Atención',
      text: "¿Realmente desea eliminar el detalle del traslado?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    });
    if (result.isConfirmed) {
      try {
        await firstValueFrom(this.transferConstructionSiteDetailService.deleteSomeDetails(selectedIds));
        this.toastHandlerService.showToast('success', `El detalle del traslado fue eliminado exitosamente.`);
        this.clearSelectionTrigger++;
        this.getUpdateListDetailByDelete();
        this.isFormView = false;
      } catch (error) {
        console.error('Error al eliminar el detalle del traslado.', error);
      }
    }
  }

  async editTransferConstructionSiteDetail(id: number) {
    const response = await this.getTransferConstructionSiteDetail(id);
    if (response) {
      this.transferConstructionSiteDetail = response;
      this.getFormView(true);
    }
  }

  async getArticlesForDetailsAsync() {
    try {
      this.dataArticle = await firstValueFrom(this.transferConstructionSiteDetailService.getArticlesForDetails(this.pageArticle,
        this.limitArticle, this.columnSortArticle, this.ascendantArticle, this.filtersArticle,
        this.transferConstructionSiteModel.transferConstructionSiteId));
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de los stocks de cada articulo en centro de costos de origen.', error);
    }
  }

  getCostCenterPriceOpen(costCenterPrice: CostCenterPriceModel) {
    this.costCenterPriceContract = costCenterPrice;
    this.openFromCostCenterPrice = "createRemissionDetail";
    this.openCostCenterPriceRegisterModal();
  }

  getCostCenterPriceRegister(costCenterPrice: CostCenterPriceModel) {
    if (costCenterPrice.costCenterPriceId != 0) {
      if (this.openFromCostCenterPrice == "createRemissionDetail") {
        this.costCenterPriceContract = costCenterPrice;
      } else if (this.openFromCostCenterPrice == "editRemissionDetail") {
        this.getTransferDetailsByTransferIdWithPagination();
      }
    }
  }

  async getColumnsForArticles() {
    try {
      if (this.headerArticle.length === 0) {
        this.headerArticle = await firstValueFrom(this.transferConstructionSiteDetailService.getColumnsForArticles());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta general.', error);
    }
  }

  async getColumnsForDetailsTransferConstructionSite() {
    try {
      this.detailHeader = await firstValueFrom(this.transferConstructionSiteDetailService.getColumnsForDetailsTransferConstructionSite());
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta general.', error);
    }
  }

  async getConceptInvoicingId(conceptInvoicingId: number) {
    this.conceptInvoicingId = conceptInvoicingId;
  }

  getDefaultActions(): TableAction[] {
    if (this.accessCostCenterPrice) {
      return [
        {
          label: 'Editar',
          icon: 'pi pi-pencil',
          action: 'edit'
        },
        {
          label: 'Precio',
          icon: 'pi pi-dollar',
          action: 'prices-cost-center'
        }
      ];
    } else {
      return [
        {
          label: 'Editar',
          icon: 'pi pi-pencil',
          action: 'edit'
        }
      ];
    }
  }

  getFormView(isFormView: boolean) {
    this.isFormView = isFormView;
  }

  async getTransferDetailsByTransferIdWithPagination() {
    try {
      this.detailData = await firstValueFrom(this.transferConstructionSiteDetailService.getTransferDetailsByTransferIdWithPagination(this.page,
        this.limit, this.columnSort, this.ascendant,
        this.transferConstructionSiteModel.transferConstructionSiteId));
      this.hasQuantityInZero.emit(this.detailData.items.some(detail => detail.quantity === 0));
      this.emitQuantityDetails.emit(this.detailData.totalItems);
    } catch (error) {
      console.error('Error al buscar los detalles del traslado entre obras.', error);
    }
  }

  async getTransferConstructionSiteDetail(id: number) {
    try {
      return await firstValueFrom(this.transferConstructionSiteDetailService.getTransferConstructionSiteDetailById(id));
    } catch (error) {
      console.error("Error al obtener transferConstructionSiteDetail.", error);
      return null;
    }
  }

  async getTransferConstructionSiteDetailByKeys(storeId: number, articleId: number): Promise<TransferConstructionSiteDetailModel> {
    try {
      return await firstValueFrom(
        this.transferConstructionSiteDetailService.getTransferConstructionSiteDetailByKeys(
          this.transferConstructionSiteModel.transferConstructionSiteId, storeId, articleId)
      );
    } catch (error) {
      console.error('Error al obtener el detalle del traslado por claves.', error);
      return new TransferConstructionSiteDetailModel();
    }
  }

  async getUpdateListDetail() {
    await this.getTransferDetailsByTransferIdWithPagination();
  }

  getUpdateListDetailByDelete() {
    this.transferConstructionSiteDetail = new TransferConstructionSiteDetailModel();
    this.clearSelectionTrigger++;
    this.getUpdateListDetail();
  }

  async getWindowsByUserAuthenticated() {
    try {
      const windowsByUserAuthenticated = await firstValueFrom(this.windowService.getWindowsByUserAuthenticated());
      this.accessCostCenterPrice = windowsByUserAuthenticated.some(x => x.windowId === WindowEnums.CostCenterPrice && x.updatable);
    } catch (error) {
      console.error('Error al buscar las ventanas del usuario autenticado.', error);
    }
  }

  async handleSelectedItem(selectedItem: any) {
    if (selectedItem.length == 1) {
      const [{ articleId, storeId, quantity }] = selectedItem;
      const response = await this.getTransferConstructionSiteDetailByKeys(storeId, articleId);
      if (response.transferConstructionSiteDetailId === 0) {
        response.articleId = articleId;
        response.storeId = storeId;
        response.quantity = quantity;
        this.transferConstructionSiteDetail = response;
      } else {
        this.transferConstructionSiteDetail = response;
      }
    } else {
      const newDetails = selectedItem.map((element: {
        orderId: number,
        articleId: number,
        storeId: number
      }) => {
        const newOrderDetail = new TransferConstructionSiteDetailModel();
        newOrderDetail.transferConstructionSiteId = this.transferConstructionSiteModel.transferConstructionSiteId;
        newOrderDetail.articleId = element.articleId;
        newOrderDetail.storeId = element.storeId;
        return newOrderDetail;
      });
      this.transferConstructionSiteDetails = newDetails;
    }
  }

  async onAction(event: { action: string, item?: TransferConstructionSiteDetailRegisterModel, selectedItems?: number[] }) {
    switch (event.action) {
      case 'edit':
        await this.editTransferConstructionSiteDetail(event.item!.id);
        break;
      case 'prices-cost-center':
        await this.prepareCostCenterPrice(event.item!.id);
        break;
      case 'bulk-delete':
        if (event.selectedItems) {
          this.deleteTransferConstructionSiteDetail(event.selectedItems);
        }
        break;
    }
  }

  async openArticleSelectionModal() {
    this.filtersArticle = [];
    await this.getColumnsForArticles();
    await this.getArticlesForDetailsAsync();
    this.updateInputs();
    this.articleSelectionModalComponent && this.articleSelectionModalComponent.show();
  }

  openCostCenterPriceRegisterModal() {
    this.inputsForCostCenterPriceRegisterModals$.next({
      blockForm: this.disabledDetail, costCenterPriceModel: this.costCenterPriceContract,
      openFrom: this.openFromCostCenterPrice
    });
    this.costCenterPriceRegisterComponent && this.costCenterPriceRegisterComponent.show();
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filtersArticle = this.removeDuplicates(filters);
    this.filtersArticle.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    this.getUpdateListDetail();
  }

  async onPageChangeArticle(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageArticle = event.page;
    this.limitArticle = event.pageSize;
    this.columnSortArticle = event.sortField || null;
    this.ascendantArticle = event.sortOrder === 1;
    await this.getArticlesForDetailsAsync();
  }

  private async prepareCostCenterPrice(id: number) {
    const transferConstructionSiteDetail = await this.getTransferConstructionSiteDetail(id);
    if (!transferConstructionSiteDetail) { return; }
    const contract = new CostCenterPriceModel();
    contract.costCenterId = this.transferConstructionSiteModel.destinyCostCenterId;
    contract.conceptInvoicingId = this.conceptInvoicingId;
    contract.articleId = transferConstructionSiteDetail.articleId;
    this.costCenterPriceContract = contract;
    this.openFromCostCenterPrice = "editRemissionDetail";
    this.openCostCenterPriceRegisterModal();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersArticle = this.filtersArticle.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersArticle.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  updateInputs() {
    this.inputsForArticlesSelection$.next({
      headers: this.headerArticle,
      data: this.dataArticle,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: true,
      limitPaginator: true,
      filters: this.filtersArticle,
      actions: [
        {
          label: 'Imágenes',
          icon: 'pi pi-image',
          action: 'view-image'
        }
      ]
    });
  }
}
